import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography, styled, useMediaQuery, useTheme, Backdrop } from '@mui/material';
import logo from './../../Assets/GentianLogo_2024.png';

export interface CheckoutSuccessProps {
  children?: React.ReactNode;
  onClose?: () => void;
  title?: string;
  message?: string;
}

const SuccessContainer = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  padding: 'var(--content-spacing-narrow)',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  borderRadius: '8px',
  boxShadow: theme.shadows[5],
  outline: 'none',
}));

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: 'var(--content-spacing)',
});

const HeaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const CheckoutPopUp: React.FC<CheckoutSuccessProps> = ({
  children,
  onClose,
  title = 'Thank you for your True Sight order.',
  message = 'Your project is now being processed and may take up to one hour to complete. You can safely close this page — processing will continue in the background. You can track your project’s progress under My Projects. We’ll also send you an email as soon as your results are ready. ',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Backdrop open sx={{ zIndex: theme.zIndex.modal + 1 }}>
      <SuccessContainer
        role="dialog"
        aria-labelledby="checkout-popup-title"
        sx={{
          width: isMobile ? '80vw' : '50vw',
          height: isMobile ? '90vh' : undefined,
          overflowY: 'auto',
        }}
      >
        <HeaderContainer>
          <div />
          <IconButton style={{ paddingTop: 0 }} onClick={() => onClose?.()}>
            <Close />
          </IconButton>
        </HeaderContainer>
        <ContentContainer>
          <img src={logo} alt="logo" style={{ maxHeight: isMobile ? '64px' : '128px' }} />
          <Typography
            id="checkout-popup-title"
            variant="h6"
            textAlign="center"
            sx={{ paddingTop: 'var(--content-spacing)' }}
          >
            {title}
          </Typography>
          <Typography sx={{ fontSize: '12px', padding: 'var(--content-spacing)' }} textAlign="center">
            {message}
          </Typography>
          <Typography sx={{ fontSize: '12px', padding: 'var(--content-spacing)' }} textAlign="center">
            You can contact us at <a href="mailto:sales@gentian.io">sales@gentian.io</a> for any questions.
          </Typography>
          {children}
        </ContentContainer>
      </SuccessContainer>
    </Backdrop>
  );
};
